import update from 'immutability-helper';
import { ProfileReduxActions } from './Action';

export const profileState: ProfileState = {
    userInfo: {
        _id: '',
        name: {
            first: '',
            last: '',
        },
        role: '',
        phoneNumber: '',
        email: '',
        recovery_mail: '',
        registeredOn: '',
        userId: '',
        globalDashboardTemplateEnabled: false,
        globalDashboardTemplateId: '',
        customDashboardTemplateEnabled: false,
        customDashboardTemplateId: '',
        defaultDashboardTemplateId: '',
        twoFactorAuthentication: {
            enabled: false,
            setupCompleted: false,
        },
    },
};

const ProfileStateReducer = (
    state = profileState,
    action: any = { type: '', payload: {} }
): ProfileState => {
    switch (action.type) {
        case ProfileReduxActions.SET_PROFILE_DATA:
            return update(state, {
                $merge: {
                    ...action.payload,
                },
            });
        case ProfileReduxActions.UPDATE_TEMPLATE_ID:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                        customDashboardTemplateId: action.payload,
                        customDashboardTemplateEnabled: true,
                    },
                },
            });
        case ProfileReduxActions.UPDATE_GLOBALLY_TEMPLATE_ID:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                        globalDashboardTemplateId: action.payload,
                        globalDashboardTemplateEnabled: true,
                    },
                },
            });

        case ProfileReduxActions.UPDATE_CUSTOM_TEMPLATE_STATUS:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                        customDashboardTemplateEnabled: action.payload,
                    },
                },
            });
        case ProfileReduxActions.UPDATE_GLOBALLY_TEMPLATE_STATUS:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                        globalDashboardTemplateEnabled: action.payload,
                    },
                },
            });
        case ProfileReduxActions.UPDATE_MOBILE_NUMBER:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                        phoneNumber: action.payload,
                    },
                },
            });
        case ProfileReduxActions.UPDATE_2FA_STATUS:
            return update(state, {
                $merge: {
                    userInfo: {
                        ...state.userInfo,
                    },
                },
            });
        default:
            return state;
    }
};

export default ProfileStateReducer;
